import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import InputField from '@commonComponents/formComponents/CustomInputField'
import SearchableDropdown from '@EUForms/searchableDropdown'


export const InvoiceLine2 = React.memo(
  ({
    procedure,
    dataSource: { invoiceId, deliveryTerms, natureOfTransaction = '' },
    onChange,
    incoTermsList,
    countryList,
    renderAtLast,
    onBlur,
    translate,
    invoiceIndex,
    validateInvoice,
    isImportShipment,
    isInvoiceDisabled
  }) => {
    const onChangeHandler = useCallback(
      ({ target: { value, name } }) =>
        onChange({ invoiceId, data: { deliveryTerms: { ...deliveryTerms, [name]: value} } }),
      [invoiceId, onChange, deliveryTerms]
    )
    const onDropDownChange = useCallback(
      (e, { value, name }) => {
        if (name == 'valuationMethod' || name == 'natureOfTransaction') {
          if (validateInvoice) validateInvoice(invoiceIndex, name, value)
          onBlur({ data: { [name]: value }, invoiceId })
          onChange({ invoiceId, data: { [name]: value } })
        } else {
          if (validateInvoice) validateInvoice(invoiceIndex, name, value)
          onBlur({ data: { deliveryTerms: { [name]: value } }, invoiceId })
          onChange({ invoiceId, data: { deliveryTerms: { ...deliveryTerms, [name]: value, } } })
        }
      },
      [invoiceId, onBlur, onChange, deliveryTerms]
    )
    const onBlurHandler = useCallback(
      ({ target: { value, name } }) =>
        onBlur({ data: { deliveryTerms: { [name]: value } }, invoiceId }),
      [invoiceId, onBlur]
    )
    return (
      <>
        {(isImportShipment || (!isImportShipment&&procedure !== 'B3')) && (
          <Grid.Column>
            <DropDown
              isLabel={true}
              id={`${invoiceId}-deliveryTerms.incoTerms`}
              type='text'
              label="DELIVERY_TERMS"
              boxNumber={'4/1'}
              value={deliveryTerms?.incoTerms}
              text={deliveryTerms?.incoTerms}
              data={incoTermsList}
              name='incoTerms'
              clearable
              clearInput={false}
              onChange={onDropDownChange}
              isDisabled={isInvoiceDisabled}
            />
          </Grid.Column>
        )}
        {/* {isImportShipment && (
          <Grid.Column>
            <SearchableDropdown
              id={`${invoiceId}-deliveryTerms.unloc`}
              label='UNLOC'
              name='unloc'
              dropdownType='unlocode'
              selectedValue={deliveryTerms?.unloc}
              onSelect={({ value }) => onDropDownChange(_, { value, name: 'unloc' })}
            />
          </Grid.Column>
        )} */}
        {(isImportShipment || (!isImportShipment&&procedure !== 'B3')) && (
          <>
            <Grid.Column>
              <InputField
                isLabel={false}
                id={`${invoiceId}-deliveryTerms.place`}
                type='text'
                label="PLACE"
                value={deliveryTerms?.place}
                name='place'
                clearInput={false}
                onChange={onChangeHandler}
                onBlur={onBlurHandler}
                isDisabled={isInvoiceDisabled}
              />
            </Grid.Column>
            <Grid.Column>
              <DropDown
                isLabel={true}
                id={`${invoiceId}-deliveryTerms.country`}
                type='text'
                label="COUNTRY"
                value={deliveryTerms?.country}
                text={deliveryTerms?.country}
                data={countryList}
                clearable
                name='country'
                clearInput={false}
                onChange={onDropDownChange}
                isDisabled={isInvoiceDisabled}
              />
            </Grid.Column>
          </>
        )}
        {/* {isImportShipment && (
          <Grid.Column>
            <InputField
              isLabel={false}
              id={`${invoiceId}-deliveryTerms.description`}
              type='text'
              label="TEXT"
              value={deliveryTerms?.description}
              clearInput={false}
              name='description'
              onChange={onChangeHandler}
              onBlur={onBlurHandler}
              isDisabled={isInvoiceDisabled}
            />
          </Grid.Column>
        )} */}
        {renderAtLast &&
          renderAtLast({
            onDropDownChange,
            translate,
            dataSource,
            isInvoiceDisabled
          })}
      </>
    )
  }
)

InvoiceLine2.defaultProps = {
  translate: (value) => value,
}
